<template>
  <div class="home" :class="{'limit': $config.settings.onlayReg}">
    <div class="fixedLeft" v-if="false">
      <div v-if="!this.isLogin" class="fixedLeftExhibitor fixedLeftDiv" @click="goExhibitor()">
        <img :src="exhibitor" />
        <p class="fixedLeftP">{{ $t('homes.exhibitor') }}</p>
      </div>
      <div v-if="!this.isLogin" class="fixedLeftPerson fixedLeftDiv" @click="goPerson()">
        <img :src="person" />
        <p class="fixedLeftP">{{ $t('homes.person') }}</p>
      </div>
      <div v-if="this.isLogin" class="fixedLeftPerson fixedLeftDiv" @click="goMessage(onlineServices)">
        <img :src="message" />
        <p class="fixedLeftP">{{ $t('Online Service') }}</p>
      </div>
      <div v-else-if="!this.isLogin">
        <TouristChat :action="'1'" />
      </div>
      <div class="fixedLeftGoTop fixedLeftDiv" @click="goTopScroll()">
        <img :src="goTop" />
      </div>
    </div>
    <v-floating-bar v-if="$store.state.config.hideElement" />
    <home-top-banner v-if="this.bannerList.length!=0" class="homeTopBanner" :option="bannerList"></home-top-banner>
    <template v-else>
      <div class="noBannerList"></div>
    </template>
    <div class="homeW homeStep" v-if="false">
      <img v-if="language == 'zh'"
        src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/home/stepCn.png" />
      <img v-else src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/home/stepEn.png" />
    </div>
    <homeBanner class="homeW homeBanner" v-if="this.carouselArr.length!=0" :option="carouselArr"></homeBanner>
    <home-data-show v-if="dataShow.length!=0" :dataShow="dataShow" class="homeW homeDataShow"></home-data-show>

    <div class="youLike" v-if="bannerHotIndustryList.length != 0">
      <!-- <p class="homeTipsTitle">{{ $t('晋江热门产业') }}</p> -->
      <homeHotIndustry class="homeW homeYouMayLike" :bannerHotIndustryList="bannerHotIndustryList"></homeHotIndustry>
    </div>

    <div class="youLike" v-if="bannerOverseasChineseMerchantList.length != 0">
      <p class="homeTipsTitle">{{ $t('港澳台和海外侨商') }}</p>
      <homeOverseasChineseMerchant class="homeW homeYouMayLike"
        :bannerOverseasChineseMerchantList="bannerOverseasChineseMerchantList"></homeOverseasChineseMerchant>
    </div>



    <!-- <HomeHotExhibits class="homeW" /> -->
    <!-- <HomeNews /> -->
    <!-- <home3DFloorplanGuide class="homeW home3DFloorplanGuide"></home3DFloorplanGuide> -->
    <div class="Stream"
      v-if="(recordsList.length != 0 || recordsRecommendList.length != 0) && (subjectType == 'VISITOR' || subjectType == '')">
      <p class="homeTipsTitle">{{ $t('homes.liveStream') }}</p>
      <home-live-stream v-if="recordsList.length != 0 && (subjectType == 'VISITOR' || subjectType == '')"
        class="homeW homeLiveStream" :option="recordsList"></home-live-stream>
      <div class="homeW homeDivider"
        v-if="recordsRecommendList.length != 0 && (subjectType == 'VISITOR' || subjectType == '')"></div>
      <home-live-stream-list v-if="recordsRecommendList.length != 0 && (subjectType == 'VISITOR' || subjectType == '')"
        class="homeW homeLiveStreamList" :option="recordsRecommendList"></home-live-stream-list>
    </div>
    <homeBrandMuseum v-if="(subjectType == 'VISITOR' || subjectType == '')" class="homeBrandMuseum"
      :option="brandMuseumList"></homeBrandMuseum>
    <div class="youLike" v-if="youMayLike.length != 0 && (subjectType == 'VISITOR' || subjectType == '')">
      <p class="homeTipsTitle">{{ $t('homes.youMayLike') }}</p>
      <home-you-may-like class="homeW homeYouMayLike" :youMayLike="youMayLike"></home-you-may-like>
    </div>
    <!-- 推荐展商 s -->
    <home-featured-exhibitors @callback="recommendedExhibitors" :language="language"
      :exhFeatured="recomendExhibitorsData"
      v-if="(subjectType == 'VISITOR' || subjectType == '')&&true"></home-featured-exhibitors>
    <div class="concurrent" v-if="concurrentEvents.length != 0">
      <p class="homeTipsTitle">{{ $t('homes.concurrentEvents') }}</p>
      <home-concurrent-events class="homeW homeConcurrentEvents"
        :concurrentEvents="concurrentEvents"></home-concurrent-events>
    </div>
    <div style="height: 40px;width:100%"></div>
    <div class="homeFooter">
      <div class="homeW homeFooterBox" v-if="false">
        <home-footer v-if="$store.state.config.hideElement"></home-footer>
      </div>
    </div>
    <div class="limit_master" v-if="$config.settings.onlayReg" @click="noVisitorTodoAction"></div>
    <noticDialogChrome></noticDialogChrome>
  </div>
</template>

<script>
// import stepCn from '@/assets/homeImages/stepCn.png'
// import stepEn from '@/assets/homeImages/stepEn.png'

import face from '@/assets/homeImages/face.png'
import link from '@/assets/homeImages/link.png'
import ins from '@/assets/homeImages/ins.png'
import pin from '@/assets/homeImages/pin.png'
import tw from '@/assets/homeImages/tw.png'
import wechat from '@/assets/homeImages/wechat.png'
import downloadQRcode from '@/assets/homeImages/downloadQRcode.png'

import exhibitor from '@/assets/homeImages/exhibitor.png'
import person from '@/assets/homeImages/person.png'
import message from '@/assets/homeImages/message.png'
import goTop from '@/assets/homeImages/goTop.png'

import homeTopBanner from './index/indexTopBanner.vue'
import homeBanner from './index/indexBanner.vue'
import homeDataShow from './index/indexDataShow.vue'
// import HomeNews from './index/HomeNews'
// import HomeHotExhibits from './index/HomeHotExhibits'
// import home3DFloorplanGuide from './index/index3DFloorplanGuide.vue'
import homeLiveStream from './index/indexLiveStream.vue'
import homeLiveStreamList from './index/indexLiveStreamList.vue'
import homeBrandMuseum from './index/indexBrandMuseum.vue'

import homeFeaturedExhibitors from './index/indexFeaturedExhibitors.vue'
import homeYouMayLike from './index/indexYouMayLike.vue'
import homeConcurrentEvents from './index/indexConcurrentEvents.vue'

import homeFooter from './index/indexFooter.vue'

import homeHotIndustry from './index/indexHotIndustry.vue'
import homeOverseasChineseMerchant from './index/indexOverseasChineseMerchant.vue'

import FloatingBar from './index/FloatingBar.vue'



import noticDialogChrome from '@/components/dialog/noticDialogChrome.vue'
import TouristChat from '@/components/chat/TouristChat'
import '../styles/index.styl'

import { mapState, mapGetters } from 'vuex'
import { 
  getConfigurationItemList, 
  getRecommendProductList, 
  getQueryList 
} from '@/api/home'
import { getRecommendedExhibitorsList } from '@/api/find'
import { 
  // allocationCustomerService, 
getFetchList } from '@/api'
export default {
  name: 'Home',
  components: {
    homeTopBanner,
    homeBanner,
    homeDataShow,
    // HomeHotExhibits,
    // home3DFloorplanGuide,
    homeLiveStream,
    homeLiveStreamList,
    homeBrandMuseum,
    homeFeaturedExhibitors,
    homeYouMayLike,
    homeConcurrentEvents,
    homeFooter,
    // HomeNews,
    noticDialogChrome,
    TouristChat,
    homeHotIndustry,
    homeOverseasChineseMerchant,
    'v-floating-bar': FloatingBar,
  },
  data() {
    return {
      // stepCn: stepCn,
      // stepEn: stepEn,
      face: face,
      link: link,
      ins: ins,
      pin: pin,
      tw: tw,
      wechat: wechat,
      downloadQRcode: downloadQRcode,
      exhibitor: exhibitor,
      person: person,
      message: message,
      goTop: goTop,
      carouselArr: [],
      dataShow: [],
      recordsList: [],
      brandMuseumList: [],
      recordsRecommendList: [],
      youMayLike: [],
      concurrentEvents: [],
      recomendExhibitorsData:[],
      bannerHotIndustryList: [],
      bannerOverseasChineseMerchantList: [],
      num: 1,
      bannerList: [],
      step: '',
    }
  },
  computed: {
    ...mapState(['onlineServices']),
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
  },
  methods: {
    sortSequence(a, b) {
      return a.sequence - b.sequence
    },
    goTopScroll() {
      cancelAnimationFrame(timer)
      var timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop
        if (oTop > 0) {
          scrollBy(0, -50)
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
        }
      })
    },
    goExhibitor() {
      if (!this.ActorNoTodo()) return
      window.PC.$RangersEvent("Homepagesuspension_Exhibitors_Click")
      this.$store.commit('SET_SUBJECTTYPE', 'ACTOR')
      this.loginSource('/login/actor')
    },
    goPerson() {
      window.PC.$RangersEvent("Homepagesuspension_visitor_Click")
      this.$store.commit('SET_SUBJECTTYPE', 'VISITOR')
      this.loginSource('/login/person')
    },
    goMessage(item){
      window.PC.$RangersEvent("Homepagesuspension_OnlineService_Click")
      item.position = this.$t('Online Service')
      this.$store.commit('setReceiver', item)
      this.$store.commit('toogleChatDialog')
    },
    getHomeTopBannerList() {
      getConfigurationItemList({
        sourceType: 1
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            // 顶部轮播图
            if (res.data.bannerMap['PC_TOP_SWIPER_BANNER'] && res.data.bannerMap['PC_TOP_SWIPER_BANNER'].length != 0) {
              for(let i in res.data.bannerMap['PC_TOP_SWIPER_BANNER']) {
                console.log(res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'], "res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType']")
                if(res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'TAG_EXHIBITOR'||res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'ACTOR_DETAILS'|| res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i]['urlType'] === 'TAG_PRODUCT') {
                  this.bannerList.push(res.data.bannerMap['PC_TOP_SWIPER_BANNER'][i])
                }
              }
              this.bannerList.sort(this.sortSequence)
            }
            // 顶部轮播图下方图片
            if (res.data.bannerMap['HOMESTEP'] && res.data.bannerMap['HOMESTEP'].length != 0) {
              for(let i in res.data.bannerMap['HOMESTEP']) {
                if(res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'TAG_EXHIBITOR'||res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'ACTOR_DETAILS'|| res.data.bannerMap['HOMESTEP'][i]['urlType'] === 'TAG_PRODUCT') {
                  this.step = res.data.bannerMap['HOMESTEP'][0]['coverIcon'] || ''
                }
              }
            }
            // 轮播视频
            if (res.data.bannerMap['PC_SWIPER_VIDEO'] && res.data.bannerMap['PC_SWIPER_VIDEO'].length != 0) {
              var arr = []
              for(let i in res.data.bannerMap['PC_SWIPER_VIDEO']) {
                if(res.data.bannerMap['PC_SWIPER_VIDEO'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_SWIPER_VIDEO'][i]['urlType'] === 'PC_TOP_BANNER') {
                  arr.push(res.data.bannerMap['PC_SWIPER_VIDEO'][i])
                }
              }
              console.log(arr)
              if (arr.length > 0) {
                for( let i in arr) {
                  this.carouselArr.push({
                    'name': arr[i]['title'],
                    'picture': arr[i]['coverIcon'],
                    'type': arr[i]['urlType'],
                    'index': arr[i]['id'],
                    'externalLink': arr[i]['url'],
                    'url': arr[i]['videoUrl'], 
                    'isImge': arr[i]['videoUrl'] ? false : true
                  })
                }
                this.carouselArr.sort(this.sortSequence)
              } else {
                this.carouselArr = []
              }
              
              
              // console.log(this.carouselArr)
            }
            
            // let data = res.data.bannerMap['HOME']
            // 腰部轮播图
            if (res.data.bannerMap['HOME'] && res.data.bannerMap['HOME'].length != 0) {
              for(let i in res.data.bannerMap['HOME']) {
                if(res.data.bannerMap['HOME'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['HOME'][i]['urlType'] === 'TAG_EXHIBITOR'||res.data.bannerMap['HOME'][i]['urlType'] === 'ACTOR_DETAILS'|| res.data.bannerMap['HOME'][i]['urlType'] === 'TAG_PRODUCT') {
                  this.brandMuseumList.push(res.data.bannerMap['HOME'][i])
                }
              }
              this.brandMuseumList.sort(this.sortSequence)
            }
            console.log('this.brandMuseumList:', this.brandMuseumList)

            // 首页热门产业
            if (res.data.bannerMap['PC_HOME_HOT_INDUSTRY'] && res.data.bannerMap['PC_HOME_HOT_INDUSTRY'].length != 0) {
              for(let i in res.data.bannerMap['PC_HOME_HOT_INDUSTRY']) {
                if(res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'TAG_EXHIBITOR'||res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'ACTOR_DETAILS'|| res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'TAG_PRODUCT' || res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'PRODUCT_DETAILS') {
                  this.bannerHotIndustryList.push(res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i])
                }
              }
              this.bannerHotIndustryList.sort(this.sortSequence)
            }

            console.log('this.bannerHotIndustryList:', this.bannerHotIndustryList)
            

            // 首页海外侨商
            if (res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'] && res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'].length != 0) {
              for(let i in res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT']) {
                if(res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'EXTERNAL' || res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'TAG_EXHIBITOR'||res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'ACTOR_DETAILS'|| res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i]['urlType'] === 'TAG_PRODUCT' || res.data.bannerMap['PC_HOME_HOT_INDUSTRY'][i]['urlType'] === 'PRODUCT_DETAILS') {
                  this.bannerOverseasChineseMerchantList.push(res.data.bannerMap['PC_HOME_OVERSEAS_CHINESE_MERCHANT'][i])
                }
              }
              this.bannerOverseasChineseMerchantList.sort(this.sortSequence)
            }
            console.log('this.bannerOverseasChineseMerchantList:', this.bannerOverseasChineseMerchantList)
          }
        })
    },
    getHomeProductList() {
      getRecommendProductList({
        showType: 'PRODUCT_LIST',
        productSort:"recommend_custom_letter_asc",
        pageNum: 1,
        pageRows: 10
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            this.youMayLike = res.data.list
          }
        })
    },
    getHomeQueryList(parms, type) {
      getQueryList(parms)
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            if (type == 'deprecated') {
              this.recordsList = res.data.records
            } else if (type == 'recommend') {
              this.recordsRecommendList = res.data.records
            } else if (type == 'host') {
              this.concurrentEvents = res.data.records
            }
          }
        })
    },
    // eslint-disable-next-line no-unused-vars
    recommendedExhibitors(param={}){//推荐展商
      const loading=this.$loading({
        lock:true,
      })
      getRecommendedExhibitorsList({
        showType:'ACTOR_LIST',
        exhibitorSort: "recommend_custom_letter_asc",
        pageNum:1,
        pageRows:12
      }).then(res=>{
        if(res.data.code==1000){
          let arr=res.data.data.list;
          arr=arr.length>12?arr.splice(0,12):arr
          this.recomendExhibitorsData=arr
        }
      }).finally(()=>{
        loading.close();
      })
    }
  },
  async mounted() {
    
    this.dataShow = this.$config.dataShow
    // 已登陆时，区分客商(VISITOR)与展商(ACTOR)
    // isLogin为true是已登录  为false是游客
    if (this.isLogin) {
      if (this.subjectType == 'VISITOR') {
        // 获取首页头部banner图
        this.getHomeTopBannerList()
        // 按时间排序 展商
        this.getHomeQueryList({ liveState: 0, liveParty: 2, orderDesc: 1 }, 'deprecated')
        // 按推荐排序 展商
        this.getHomeQueryList({ sponsorRecommendation: 1 }, 'recommend')
        // 主办 直播
        this.getHomeQueryList({ liveState: 0, liveParty: 1 }, 'host')
        // 获取推荐展品列表
        this.getHomeProductList()
      } else if (this.subjectType == 'ACTOR') {
        // 获取首页头部banner图
        this.getHomeTopBannerList()
        // 主办 直播
        this.getHomeQueryList({ liveState: 0, liveParty: 1 }, 'host')
      }
      // if (this.onlineServices.length === 0 && this.isLogin) {
        // TODO
        // allocationCustomerService({}).then(res => {
        //   this.$store.commit('setOnlineServices', res.data.data)
        // })
        await getFetchList({})
          .then(res => {
            return res.data
          })
          .then(res => {
            if (res.data) {
              // res.data.config && this.$store.commit('setOnlineServiceTel', res.data.config.customServiceTelephone)
              this.$store.commit('SET_CONFIGSWITCH', res.data.configSwitch)
            }
          })
      // }
    } else {
      // 获取首页头部banner图
      this.getHomeTopBannerList()
      // 按时间排序 展商
      this.getHomeQueryList({ liveState: 0, liveParty: 2, orderDesc: 1 }, 'deprecated')
      // 按推荐排序 展商
      this.getHomeQueryList({ sponsorRecommendation: 1 }, 'recommend')
      // 主办 直播
      this.getHomeQueryList({ liveState: 0, liveParty: 1 }, 'host')
      // 获取推荐展品列表
      this.getHomeProductList()
    }
    
  },
  created() {
    this.recommendedExhibitors()
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/index'

.hide{
  display:none;
}
.Stream{
  width: 100%;
  max-height 1167px;
  background: $color-index-stream-bg url('../assets/homeImages/bg-events-img.png') no-repeat ;
  background-position-y: bottom ;
}
.concurrent{
  width: 100%;
  height 741px;
  background: $color-index-stream-bg url('../assets/homeImages/bg-events-img.png') no-repeat ;
  background-position-y: bottom ;
}
.homeFooter{
  .at4-visually-hidden{
    width 400px
    height 400px
  }
}
</style>

<style lang="stylus">
  .limit {
    .limit_master {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      z-index: 999;
    }

    .fixedLeft {
      z-index: 1002;
      background: $color-main;
    }

    .homeTopBanner,
    .homeBanner,
    .homeBrandMuseum {
      position relative;
      z-index: 1000;
    }

    .homeBanner {
      z-index: 1001;
    }

    .v-video-box .v-video-wrap {
      height: 60%;
    }
  }
</style>
